import { render, staticRenderFns } from "./unKnown.vue?vue&type=template&id=2d7513f0&scoped=true&"
import script from "./unKnown.vue?vue&type=script&lang=js&"
export * from "./unKnown.vue?vue&type=script&lang=js&"
import style0 from "./unKnown.vue?vue&type=style&index=0&id=2d7513f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7513f0",
  null
  
)

export default component.exports